const sifa = {
  //-----------ATENCION DENUNCIAS-----------
  //Registro De Denuncia
  RegistrarDenuncia: "SIFA/RegistrarDenuncia",
  RegistrarDatosFinalesDenuncia: "SIFA/RegistrarDatosFinalesDenuncia",
  ObtenerDatosDenunciaFormulario: "SIFA/ObtenerDatosDenunciaFormulario",
  //AdministrarDenuncias
  ObtenerDenuncias: "SIFA/ObtenerDenuncias",
  EliminarDenuncia: "SIFA/EliminarDenuncia",
  //Registro de Acuerdos  
  RegistrarAcuerdo: "SIFA/RegistrarAcuerdo",
  ValidarNumeroDeExpedienteDenuncia: "SIFA/ValidarNumeroDeExpedienteDenuncia",
  ObtenerAcuerdosDelDia: "SIFA/ObtenerAcuerdosDelDia",
  GenerarListaDeAcuerdosPDF: "SIFA/GenerarListaDeAcuerdosPDF",
  //-----------REPORTES-----------
  //Lista de Acuerdos
  GuardarNuevaListaDeAcuerdos : "SIFA/GuardarNuevaListaDeAcuerdos",
  AgregarRutaListaDeAcuerdos: "SIFA/AgregarRutaListaDeAcuerdos",
  //Listas de Acuerdos Publicadas
  ObtenerListasDeAcuerdosPublicadas : "SIFA/ObtenerListasDeAcuerdosPublicadas",
}
export default sifa;



//////////////////
// WEBPACK FOOTER
// ./static/js/api/SIFA/funcion/sifa.js
// module id = null
// module chunks = 